import store from './store';
import { logout } from '../features/common/authSlice';

export const handleSessionExpired = () => {
  store.dispatch(logout());

  if (window.self !== window.top) {
    window.dispatchEvent(new Event('bbs-cms:sso-session-lost'));
  } else {
    window.location.href = '/login';
  }
};
